import React from 'react';

import { Paragraph } from '@zillow/constellation';

import PeopleInformation from './PeopleInformation';
import { PERSON_TYPE } from '../../../constants/stringConstants';
import type { PeopleSection } from '../../../models/index';

type Props = {
  section: PeopleSection;
  setSection: (section: PeopleSection) => void;
  setSectionValues: (keyValuePairs: object) => void;
};

export const MAX_TENANTS = 8;

function TenantInformation_v1({ section, setSection, setSectionValues }: Props) {
  return (
    <>
      <Paragraph fontType="h6">Tell us about your tenants</Paragraph>
      <Paragraph marginBottom="sm">
        Add each tenant’s Zillow account email for signing the lease ({MAX_TENANTS} max). You can add non-signing
        occupants such as children later.
      </Paragraph>
      <PeopleInformation
        isOptional={false}
        maximumPeople={MAX_TENANTS}
        personType={PERSON_TYPE.TENANT}
        setSectionValues={setSectionValues}
        setSection={setSection}
        section={section}
        addressLabel="Address for receiving notices prior to the lease’s start date"
      />
    </>
  );
}

TenantInformation_v1.description = `Basic TenantInformation component that limits total tenants to ${MAX_TENANTS}`;

export default TenantInformation_v1;
